import React from "react";

import { useSelector } from "react-redux";
import { Icon_MailThis } from "../../BP2Components/Icons/icons";
import { useWindowSize } from "@util/customHooks";
import { sortByPriority } from "../FormV2Scripts";

import PropTypes from "prop-types";
import MailModal from "./Modals/MailModal";
import projectConfig from "@projectConfig";
import IntlMessages from "@util/IntlMessages";
import PlanMessageModal from "../../Modal/PlanMessageModal/PlanMessageModal";
import MessageButtonsDropdown from "./MessageButtonsDropdown/MessageButtonsDropdown";

import "./MessageButtons.less";

const MessageButtons = ({
   buttons,
   setCurrentProcessStep,
   sysBtnsConfig,
   currentProcessStep,
   isQuestionMode,
   setRefreshFormAfterSendingCase,
   hideChat,
}) => {
   const { activeCasesFolder } = useSelector(({ settings }) => settings);
   const visibilityOptions = useSelector(({ visibilityOptions }) => visibilityOptions);
   const { width: windowWidth } = useWindowSize();

   const query = new URLSearchParams(window.location.search);
   const actionIdFromUrl = query.get("actionId");

   return (
      <div className="messages-content-container__all-buttons">
         {!projectConfig?.isSendButtonInSystemButtonsHidden ? (
            // @ts-ignore
            <MailModal
               btnClassName={"messages-content-container__all-buttons__send-button"}
               buttonType="third"
               children={
                  <>
                     <Icon_MailThis fill="currentColor" />
                     <IntlMessages id="modal.sendMessage" />
                  </>
               }
               instanceId={currentProcessStep?.instanceId}
               recordId={currentProcessStep?.sysActions?.moveForward?.body?.messageId}
            />
         ) : null}
         <MessageButtonsDropdown
            setCurrentProcessStep={setCurrentProcessStep}
            systemButtons={buttons.systemButtons}
            normalButtons={sortByPriority(buttons.normalButtons)}
            windowWidth={windowWidth}
            currentProcessStep={currentProcessStep}
            sysBtnsConfig={sysBtnsConfig}
            isQuestionMode={isQuestionMode}
            setRefreshFormAfterSendingCase={setRefreshFormAfterSendingCase}
            hideChat={hideChat}
         />
         <span className="gx-flex-row plan-btn">
            {currentProcessStep?.planningData &&
               !projectConfig?.hidePlanningButtons &&
               (actionIdFromUrl || currentProcessStep?.instanceId) &&
               visibilityOptions?.isPlanVisible && (
                  <div className="gx-text-secondary" onClick={(e) => e.stopPropagation()}>
                     <PlanMessageModal
                        tags={currentProcessStep.planningData.tags}
                        privateTags={currentProcessStep.planningData.tags_private}
                        messageId={currentProcessStep.planningData.id}
                        start={currentProcessStep.planningData.start_time}
                        duration={+currentProcessStep.planningData?.duration || 0}
                        title={currentProcessStep.planningData.subject}
                        lockDate={currentProcessStep.planningData.is_locked_date}
                        lockedDataAndTime={currentProcessStep.planningData.is_locked}
                        deadlineDate={currentProcessStep.planningData.deadline}
                        activeCasesFolder={activeCasesFolder}
                        areStylesBasedOnCaseStatus={
                           currentProcessStep?.planningData.start_time !== null
                        }
                     />
                  </div>
               )}
         </span>
      </div>
   );
};

MessageButtons.propTypes = {
   buttons: PropTypes.object.isRequired,
   setCurrentProcessStep: PropTypes.func.isRequired,
};

export default MessageButtons;
